import { CloudController } from 'graphql/generated/graphqlTypes';
import useTranslation from 'hooks/useTranslation/useTranslation';
import { useCallback } from 'react';
import { useFilterSearchParams } from 'v2/hooks/useFilterSearchParams/useFilterSearchParams';
import { useSearch } from 'v2/hooks/useSearch/useSearch';

interface Params {
  cloudControllers: CloudController[];
}

type CloudControllerFilterParam = 'search';

const CLOUD_CONTROLLER_FILTER_PARAM_KEYS: CloudControllerFilterParam[] = ['search'];

const searchKeys = ['serialNumber'];

export const useCloudControllersSearch = ({ cloudControllers }: Params) => {
  const { translation } = useTranslation();

  const { searchParams, updateFilterParams } = useFilterSearchParams<CloudControllerFilterParam>(
    CLOUD_CONTROLLER_FILTER_PARAM_KEYS
  );

  const filterStr = searchParams.get('search') ?? '';

  const setFilterStr = useCallback(
    (value: string) => updateFilterParams(() => ({ search: value === '' ? undefined : value })),
    [updateFilterParams]
  );

  const filteredCloudControllers = useSearch({ data: cloudControllers, search: filterStr, keys: searchKeys });

  const countCaption = `${filteredCloudControllers.length} ${translation.of} ${cloudControllers.length} ${translation.cloud_controllers}`;

  return { filterStr, setFilterStr, filteredCloudControllers, countCaption };
};
